import { render } from "./DiseaseQuickCreateModal.vue?vue&type=template&id=7011cee8&scoped=true"
import script from "./DiseaseQuickCreateModal.vue?vue&type=script&lang=js"
export * from "./DiseaseQuickCreateModal.vue?vue&type=script&lang=js"

import "./DiseaseQuickCreateModal.vue?vue&type=style&index=0&id=7011cee8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7011cee8"]])

export default __exports__